import script from "./AntragStep1Header.vue?vue&type=script&setup=true&lang=js"
export * from "./AntragStep1Header.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__